import React from 'react';

function Video(props) {
  return (
    <div className="embed-responsive embed-responsive-16by9">
      <iframe className="embed-responsive-item" src={ props.src }></iframe>
    </div>
  )
}

export default Video;



/** WEBPACK FOOTER **
 ** ./src/components/presentational/Video.jsx
 **/